import Link from 'next/link';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import { Category } from '@/models/Product';
import styles from '@/styles/TruncateContent.module.css';
import CustomEventTypes from '@/utils/analytics/customEventTypes';

// import { trackCustomEvent } from '@/utils/analytics/googleAnalytics'
import LazyImage from '../LazyImage';
import Paragraph, { VARIANT } from '../Paragraph';
interface Props {
  category: Category;
  className?: string;
}
const CategoryImageName = ({
  category: {
    id,
    appDisplayName,
    name,
    imageUrl,
    slug
  },
  className = ''
}: Props) => {
  const displayName = appDisplayName || name;
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const slugEnc = encodeURIComponent(slug?.slug || '');
  const onCategoryClick = () => {
    trackCustomEvent(CustomEventTypes.OPEN_PRODUCT_LIST, displayName);
  };
  return <Link data-testid={`category-link-${id}`} href={`/products/categories/${slugEnc}`} className={`flex flex-col relative w-20 ${className}`} onClick={onCategoryClick} data-sentry-element="Link" data-sentry-component="CategoryImageName" data-sentry-source-file="CategoryImageName.tsx">
      <div className="mb-2 w-20 h-20">
        <LazyImage alt={displayName} fallBackIcon={<div className="flex justify-center items-center bg-neutral-300 rounded-full w-20 h-20 overflow-hidden">
              <span className="text-4xl">{displayName[0]}</span>
            </div>} imageUrl={imageUrl} className="rounded-full w-20 h-20 object-cover" data-sentry-element="LazyImage" data-sentry-source-file="CategoryImageName.tsx" />
      </div>
      <Paragraph className={`text-center ${styles.truncate_after_two_lines}`} variant={VARIANT.MEDIUM} data-sentry-element="Paragraph" data-sentry-source-file="CategoryImageName.tsx">
        {displayName}
      </Paragraph>
    </Link>;
};
export default CategoryImageName;